<template>
  <div>
    <el-dialog :visible.sync="showLogin" width="410px" :close-on-click-modal='false' :fullscreen="false" @close="btnCloseDialog" >
      <div class="dialog_login_body">
        <div class="pri-text1">
          微信登录
        </div>
        <div>
          <wechat-login @isLogin="onLoginSuccess"></wechat-login>
        </div>
        <div style="text-align: center">请使用微信扫描二维码登录</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="showNoTagTip" :close-on-click-modal="false" :close-on-press-escape="false"
               :show-close="false" width="450px" top="15vh">
      <div style="text-align: center;">
        <img src="~@/assets/img/contact_me_qr.png" style="height: 400px; width: 400px;" alt="">

        <div style="margin: 10px;font-size: 12px;">
          请使用微信扫码联系客服，即可获取产品使用权限。
          <br>
          点击
          <el-button type="text" size="mini" @click="refreshMacthTagViast">刷新</el-button>
          更新您的状态
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import wechatLogin from "../../components/common/wechat-login"
import userApi from "../../assets/js/userApi";

export default {
  name: "login",
  components: {wechatLogin},
  data(){
    return {
      isValidTag: window.config.active == "prod", // 是否开启标签验证， 生产开启，测试关闭
      matchTag: 'prod_数据开放平台_用户状态_通过',
      showNoTagTip: false, // 没有匹配标签的提示dialog
    }
  },
  props: {
    isLoginVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed : {
    showLogin(){
      return this.isLoginVisible;
    }
  },
  methods: {
    onLoginSuccess(isLogin) {
      if (isLogin) {
        if (this.isValidTag) {
          let _userInfo = JSON.parse(sessionStorage.getItem("USER_INFO"));
          if (_userInfo.tags.indexOf(this.matchTag)>-1) {
            this.showNoTagTip = false
            sessionStorage.setItem("USER_ISMATCHTAG", true)
            this.$emit( 'login-success' );
            this.$message.success("登录成功");
            this.$store.dispatch( "setLogin", true );
          } else {
            this.showNoTagTip = true
            sessionStorage.setItem("USER_ISMATCHTAG", false)
          }
        } else {
          this.showNoTagTip = false
          sessionStorage.setItem("USER_ISMATCHTAG", true)
          this.$emit( 'login-success' );
          this.$message.success("登录成功");
          this.$store.dispatch( "setLogin", true );
        }
      } else {
        this.$emit( 'login-faild' );
        this.$message.error("登录失败");
      }
    },

    btnCloseDialog(){
      this.$emit('closeDialog')
    },

    // 刷新获取匹配的标签
    refreshMacthTagViast(responce) {
      let token=sessionStorage.getItem("token");
      console.log('refreshMacthTagViast')
    //  userApi.getCurUsrTags(_r => {
      userApi.getCurUsrInfo(token).then(_r=>{
        let userInfo=JSON.parse(sessionStorage.getItem("USER_INFO")) ;
        console.log(_r)
        if (userInfo.tags.indexOf(this.matchTag)>-1) {
          this.showNoTagTip = false
          sessionStorage.setItem("USER_ISMATCHTAG", true)
          if (responce) responce()
        } else {
          this.showNoTagTip = true
          sessionStorage.setItem("USER_ISMATCHTAG", false)
        }
      }).catch(e=>{
        
      })
    },
  }
}
</script>

<style scoped>

.pri-text1 {
  color: #568cd5;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
}
</style>
